import { FaFolderClosed } from 'react-icons/fa6'
import { IoDocumentText } from 'react-icons/io5'
import { MdDelete, MdOutlineOndemandVideo } from 'react-icons/md'
import { FaRegStar, FaStar } from 'react-icons/fa6'
import { FaRegEye, FaRegThumbsUp } from 'react-icons/fa'
import { useState } from 'react'

export const FolderView = ({
	folders = [],
	documents = [],
	onOpen,
	formatDate,
	onDeleteDocument,
	onDeleteFolder,
	onLike,
	onFavorite,
	isHR = false,
	onView,
	isEmployee,
	employeesImages,
}) => {
	const getIconByExtension = fileName => {
		const ext = fileName?.toLowerCase().split('.').pop()
		const docExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt']
		const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'webm']
		if (docExts.includes(ext)) return <IoDocumentText className='tw-text-blue-500' />
		if (videoExts.includes(ext)) return <MdOutlineOndemandVideo className='tw-text-red-500' />
		return null
	}
	const [deleteModal, setDeleteModal] = useState({
		open: false,
		itemName: '',
		onConfirm: null,
	})

	const employeeId = JSON.parse(localStorage.getItem('user'))?.id

	return (
		<div className='tw-mt-6 tw-pr-2'>
			<div className='tw-grid tw-grid-cols-12 border-bottom tw-text-gray-600 tw-text-sm md:tw-text-base tw-font-medium tw-px-2 md:tw-px-4 tw-py-2'>
				<span className='tw-col-span-6 md:tw-col-span-5 lg:tw-col-span-5'>Nombre</span>
				<span className='tw-col-span-4 md:tw-col-span-4 lg:tw-col-span-4'>Autor</span>
				<span className='tw-hidden md:tw-block tw-col-span-2 lg:tw-col-span-2'>Última modificación</span>
				<span className='tw-col-span-2 md:tw-col-span-1 lg:tw-col-span-1 tw-text-center'>Acciones</span>
			</div>

			{folders.map(folder => (
				<div
					key={folder.id}
					onClick={() => onOpen(folder.id)}
					className='tw-grid tw-grid-cols-12 border-bottom tw-items-center tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 hover:tw-bg-gray-50 tw-cursor-pointer tw-text-sm md:tw-text-base'
				>
					<div className='tw-flex tw-items-center tw-gap-2 md:tw-gap-3 tw-col-span-6 md:tw-col-span-5 lg:tw-col-span-5'>
						<FaFolderClosed className='tw-text-alert-500' />
						<span className='tw-truncate'>{folder.name}</span>
					</div>
					<div className='tw-col-span-4 md:tw-col-span-4 lg:tw-col-span-4 tw-truncate'>
						<span className='tw-text-gray-500'>-</span>
					</div>
					<div className='md:block tw-col-span-2 lg:tw-col-span-2 tw-text-sm'>{formatDate(folder.createdAt || '')}</div>
					<div className='tw-flex tw-items-center tw-gap-2 tw-justify-center tw-col-span-2 md:tw-col-span-1 lg:tw-col-span-1'>
						{!isEmployee && (
							<MdDelete
								className='tw-cursor-pointer'
								onClick={e => {
									e.stopPropagation()
									setDeleteModal({
										open: true,
										itemName: `la carpeta "${folder.name}"`,
										onConfirm: () => onDeleteFolder(folder.id),
									})
								}}
							/>
						)}
					</div>
				</div>
			))}

			{documents.map(doc => (
				<div
					key={doc.id}
					className='tw-grid tw-grid-cols-12 tw-items-center tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 hover:tw-bg-gray-50 tw-text-sm md:tw-text-base'
				>
					<div className='tw-flex tw-items-center tw-gap-2 md:tw-gap-3 tw-col-span-6 md:tw-col-span-5 lg:tw-col-span-5 tw-min-w-0'>
						{getIconByExtension(doc.name)}
						<div className='tw-flex tw-items-center tw-gap-2 tw-min-w-0'>
							<a
								href={doc.url}
								target='_blank'
								rel='noopener noreferrer'
								className='tw-font-medium tw-text-blue-700 hover:tw-underline tw-max-w-[140px] md:tw-max-w-[180px] lg:tw-max-w-[220px] tw-truncate'
								onClick={e => {
									e.stopPropagation()
									onView && onView(doc)
								}}
								download
								title={doc.name}
							>
								{doc.name}
							</a>
							{!isEmployee && (
								<span
									className='tw-ml-2 tw-cursor-pointer'
									onClick={e => {
										e.stopPropagation()
										onFavorite && onFavorite(doc)
									}}
									title={doc.highlightedByHr ? 'Quitar recomendación RRHH' : 'Recomendar por RRHH'}
								>
									{doc.highlightedByHr ? (
										<FaStar className='tw-text-alert-400' />
									) : (
										<FaRegStar className='tw-text-gray-400 hover:tw-text-alert-400' />
									)}
								</span>
							)}
							{isEmployee && doc.highlightedByHr && <FaStar className='tw-text-alert-400 tw-ml-2' title='Recomendado por RRHH' />}
						</div>
					</div>

					<div className='tw-flex tw-items-center tw-gap-2 tw-col-span-3 md:tw-col-span-4 tw-min-w-0'>
						{doc.authorName !== 'Company' && (
							<img
								src={
									employeesImages.find(img => img.mydnaUserEmail === doc.authorEmail)?.url || 'https://assets.mydna.company/profile-placeholder.png'
								}
								alt={doc.authorName}
								className='tw-w-7 tw-h-7 tw-rounded-full tw-object-cover tw-bg-gray-200'
							/>
						)}
						<span className='tw-truncate'>{doc.authorName === 'Company' ? 'RRHH' : doc.authorName}</span>
					</div>

					<div className='tw-col-span-3 md:tw-col-span-2'>
						{formatDate(doc.createdAt)}
						<div className='tw-flex tw-gap-4 tw-mt-1 tw-text-xs tw-text-gray-500'>
							{typeof doc.viewsCount === 'number' && (
								<span className='tw-flex tw-items-center'>
									<FaRegEye className='tw-mr-1' /> {doc.viewsCount}
								</span>
							)}
							{typeof doc.likesCount === 'number' && (
								<span
									className='tw-flex tw-items-center tw-cursor-pointer hover:tw-text-blue-600'
									onClick={e => {
										e.stopPropagation()
										onLike && onLike(doc)
									}}
									title='Me gusta'
								>
									<FaRegThumbsUp className='tw-mr-1' /> {doc.likesCount}
								</span>
							)}
						</div>
					</div>

					<div className='tw-flex tw-justify-center tw-col-span-2 md:tw-col-span-1'>
						{(isHR || (isEmployee && employeeId === doc.authorId)) && (
							<MdDelete
								className='tw-cursor-pointer'
								onClick={e => {
									e.stopPropagation()
									setDeleteModal({
										open: true,
										itemName: `el documento "${doc.name}"`,
										onConfirm: () => onDeleteDocument(doc.id),
									})
								}}
							/>
						)}
					</div>
				</div>
			))}

			{folders.length === 0 && documents.length === 0 && (
				<div className='tw-text-center tw-text-base tw-text-gray-500 tw-p-4'>Ningún ítem encontrado.</div>
			)}

			{deleteModal.open && (
				<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50'>
					<div className='tw-bg-white tw-p-6 tw-rounded tw-shadow-lg tw-min-w-[350px]'>
						<div className='tw-mb-4'>
							Está a punto de eliminar <b>{deleteModal.itemName}</b>. ¿Desea continuar?
						</div>
						<div className='tw-flex tw-justify-end tw-gap-2'>
							<div
								className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
								onClick={() => setDeleteModal({ open: false, itemName: '', onConfirm: null })}
							>
								Cancelar
							</div>
							<div
								className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg'
								onClick={() => {
									if (deleteModal.onConfirm) deleteModal.onConfirm()
									setDeleteModal({ open: false, itemName: '', onConfirm: null })
								}}
							>
								Eliminar
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
